
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class CredrouteReaderService {

   public static getCreditReportHtml(
           axiosInstance: AxiosInstance, input: ServerData.CredrouteWebReader.GetCreditReportHtml$Input,
           f: (output: ServerData.CredrouteWebReader.GetCreditReportHtml$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            params : input.toJson()

         };
        return axiosInstance.get(
            'insightapi/credroute/get-credit-report-html',
            {params : input.toJson()}
        ).then((response) => ServerData.CredrouteWebReader.GetCreditReportHtml$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

